import { makeStyles, Theme } from '@material-ui/core';

const minDrawerWidth = 70;
const drawerWidth = 260;

export const useStyles = makeStyles((theme: Theme) => ({
  brandImage: {},
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxShadow: '3px 0px 6px rgba(142, 142, 142, 0.2)',
  },
  drawerOpen: {
    overflowX: 'hidden',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: '#08312A',
    color: '#fff',
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: minDrawerWidth,
    backgroundColor: '#08312A',
    color: '#fff',
  },
  drawerList: {
    paddingLeft: 14,
    fontFamily: 'Poppins, Roboto',
  },
  drawerListShift: {},
  drawerListItem: {
    paddingLeft: 8,
    fontWeight: 'bold',
    paddingTop: 6,
    paddingBottom: 6,
    color: '#fff',
  },
  drawerListItemShift: {
    paddingLeft: 8,
    paddingTop: 9,
    paddingBottom: 9,
    color: '#fff',
  },
  listSubheader: {
    fontSize: 14,
    lineHeight: '48px',
    color: '#fff',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    ...theme.mixins.toolbar,
    minHeight: 140,
  },
}));
